export class Stack<T> {
  private items: T[]
  private readonly keepFirstItem: boolean

  constructor(keepFirstItem = false, item?: T) {
    this.items = item === undefined ? [] : [item]
    this.keepFirstItem = keepFirstItem
  }

  pop() {
    const lastItem = this.items.pop()
    this.items = this.items.slice()
    return lastItem
  }

  push(...items: T[]) {
    this.items.push(...items)
    this.items = this.items.slice()
  }

  peek() {
    return this.length == 0 ? undefined : this.items[this.length - 1]
  }

  get length() {
    return this.items.length
  }

  get shouldKeepFirstItem() {
    return this.keepFirstItem
  }

  toArray() {
    return this.items
  }

  reset(...items: T[]) {
    this.items = !items?.length ? [] : items
  }

  replace(item: T) {
    this.items.pop()
    this.items.push(item)
    this.items = this.items.slice()
  }

  removeAt(index: number) {
    if (index < 0 || index >= this.items.length) return

    this.items.splice(index, 1)
    this.items = this.items.slice()
  }

  *[Symbol.iterator]() {
    for (const item of this.items) yield item
  }
}
